<template lang="pug">
div
  el-row
    el-row.marginTop
      el-col(:span="12")
        app-display(
          label="Tipo de cadastro:",
          :content="tipo",
        )
      el-col(:span="12")
        app-display(
          label="Data de cadastro:",
          :content="this.dataCadastro",
        )
      el-col(:span="12",v-if="dataRetificacao")
        app-display(
          label="Data de retificação:",
          :content="this.dataRetificacao",
        )
  el-row
    app-divider(label="Qualificação")
  el-row.margemTop
    el-col(:span="24")
      .margem
        app-display(
          label="É beneficiário originário?",
          :content="qualificacao.beneficiarioOriginario ? 'Sim' : 'Não'",
          :class = "compararQualificacaoCertidao && compararQualificacaoCertidao.mudouBeneficiarioOriginario ? 'text': '' "
        )
        app-display(
          label="A área é georreferenciada tendo sido o Título emitido de acordo com a Lei 10.267/01? ",
          :content="qualificacao.areaGeorreferenciada ? 'Sim' : 'Não'",
          :class = "compararQualificacaoCertidao && compararQualificacaoCertidao.mudouAreaGeorreferenciada ? 'text': '' "
        )
        app-display(
          label="A área está matriculada?",
          :content="qualificacao.areaMatriculada ? 'Sim' : 'Não'",
          :class = "compararQualificacaoCertidao && compararQualificacaoCertidao.mudouAreaMatriculada ? 'text': '' "
        )
        span.pessoas Lista de pessoas que acompanham o processo
          div.viewPersonInfo(v-for="(pessoa, index) in pessoas" :key="index")
            span.text {{pessoa.nomeRazaoSocial}}
            span.text {{pessoa.documento ? pessoa.documento.nome : ''}}
            el-tooltip(
              effect='dark',
              content='Baixar arquivo',
              placement="top"
            )
              button.buttonDocument(
                v-if="pessoa.documento"
                @click="getDownload(pessoa.documento)"
              )
                font-awesome-icon(icon="download", size="lg")

</template>

<script>
import FileSaver from 'file-saver'
import axios from '@/utils/api'
import AppDisplay from './../AppDisplay'
import AppDivider from '@/components/AppDivider'

export default {

  components: {
    AppDisplay,
    AppDivider
  },

  props: {
    qualificacao: {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      required: true
    },
    dataCadastro: {
      type: String,
      required: true
    },
    pessoas: {
      type: Array,
      required: true
    },
    compararQualificacaoCertidao: {
      type: Object,
      required: false
    },
    dataRetificacao: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      showDialog: false
    }
  },

  methods: {
    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    }

  }
}
</script>

<style lang="scss" scoped>
  .margem {
    margin-left: 6px;
  }
  .margemTop {
    margin-top: 15px;
  }
  .pessoas{
    font-weight: bold;
    font-size: 14px;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  >>> .text .text{
    color: #ff0000 !important;
  }
  .viewPersonInfo{
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .text{
    font-size: 14px;
    width: 40%;
  }
  .buttonDocument{
    border: none;
    background: none;
    padding: 0;
    width: 20%;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesQualificacaoCertidao.vue